export default function (state, getters, rootState, rootGetters) {
    return rootState.settings.paymentItems.load || state.list.loading;
}